<template>
  <dx-modal title="Selecione o dia da semana"
            :value="show" @input="close" id="modal-slot-week-day-selector">
    <div class="card patient-card">
      <div class="card-header">
        <div class="card-title">Dados do paciente</div>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column col-6 mb-1">
            <strong>Nome:</strong>
            <span class="ml-1">{{ clipboard.data.patient.name }}</span>
          </div>
          <div class="column col-6 mb-1">
            <strong>Nascimento:</strong>
            <span class="ml-1">{{ clipboard.data.patient.birthDate | date }}</span>
          </div>
          <div class="column col-6">
            <strong>Celular:</strong>
            <span class="ml-1">{{ clipboard.data.patient.cellphone | phone }}</span>
          </div>
          <div class="column col-6">
            <strong>Telefone:</strong>
            <span class="ml-1">{{ clipboard.data.patient.phone | phone }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="week-days-selector">
      <div class="columns">
        <div
          v-for="day in weekDays"
          :key="day.date"
          class="column col-12 col-md-6 col-lg-4"
        >
          <button
            class="btn btn-block week-day-button"
            :class="{
              'btn-primary': selectedDate === day.date,
              'btn-gray': selectedDate !== day.date,
            }"
            @click="selectDay(day.date)"
          >
            <div class="week-day-label">{{ day.weekday }}</div>
            <div class="week-day-date">{{ day.displayDate }}</div>
            <div class="week-day-full-date">{{ formatFullDate(day.date) }}</div>
          </button>
        </div>
      </div>
    </div>

    <template slot="footer">
      <button class="btn btn-primary mr-1"
              :disabled="!selectedDate"
              @click="confirmSelection">Continuar</button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import moment from 'moment';
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
    },
    weekDays: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedDate: null,
    };
  },
  computed: {
    ...mapState({
      clipboard: ({ appointment }) => appointment.clipboard,
    }),
  },
  methods: {
    ...mapMutations({
      hideSlotWeekDaySelector: 'Appointment.HIDE_SLOT_WEEK_DAY_SELECTOR',
      showSlotModal: 'Appointment.SHOW_SLOT_MODAL',
    }),
    close() {
      this.selectedDate = null;
      this.$emit('close');
    },
    selectDay(date) {
      this.selectedDate = date;
    },
    formatFullDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    confirmSelection() {
      if (!this.selectedDate) {
        return;
      }
      this.hideSlotWeekDaySelector();
      this.$emit('day-selected', this.selectedDate);
    },
  },
};
</script>

<style lang="scss">
@import '../../../../assets/scss/variables';

#modal-slot-week-day-selector {
  .patient-card {
    background-color: $gray-color-ultra-light;
    margin-bottom: $layout-spacing;
  }

  .week-days-selector {
    margin-top: $layout-spacing;
  }

  .week-day-button {
    margin-bottom: $layout-spacing-sm;
    padding: $layout-spacing;
    text-align: center;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .week-day-label {
      font-weight: 600;
      font-size: $font-size-sm;
      margin-bottom: $unit-1;
    }

    .week-day-date {
      font-size: $font-size-lg;
      font-weight: 700;
      margin-bottom: $unit-1;
    }

    .week-day-full-date {
      font-size: $font-size-xs;
      opacity: 0.7;
    }
  }
}
</style>
